// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2652":"e1ddba2d","2706":"e1ddba2d","3091":"e1ddba2d","5472":"e1ddba2d","8153":"e1ddba2d"}[chunkId] + ".chunk.css";
};